<div
  [formGroup]="invoiceForm"
  >
  <ng-template #events>
    <app-event-select
      formControlName="events"
      [filter]="{ jobId: jobId }"
      [disabledEvents]="{
        cannotBeInvoiced: true
      }"
      [showInvoiceInfo]="true"
      [selectAllByDefault]="disableMultipleEvents$ | async"
      [limit]="(disableMultipleEvents$ | async) === true ? 1 : null"
      ></app-event-select>
    <small>You can only create an invoice for events that were completed, or were supposed to be completed, and you cannot include the same event in more than one invoice</small>
  </ng-template>
</div>

<app-mutate-object
    #mutate
    [fg]="invoiceForm"
    objectType="Invoice"
    [mutateType]="mutateType"
    [steps]="steps"
    (objectMutated)="mutateInvoice()"
></app-mutate-object>
